import { ActionV2, ResourceTypeV2 } from '../types/authorizations.types';

/**
 * General task permissions (docs/plans/orders-and-transfers.md §4.13),
 * outside Orders & Transfers so they work in a business with no module on.
 * Tasks assigned to someone need no permission to see or tick. Never
 * rename a value: roles store the permission id, and the name is checked.
 */
export const TASKS_ACTIONS = {
  CREATE: 'tasks:create',
  VIEW_ALL: 'tasks:view_all',
} as const;

export type TasksAction = (typeof TASKS_ACTIONS)[keyof typeof TASKS_ACTIONS];

export interface TasksActionDefinition {
  name: TasksAction;
  /** English label (the i18n key in the web apps). */
  label: string;
}

export const TASKS_ACTION_CATALOG: readonly TasksActionDefinition[] = [
  { name: TASKS_ACTIONS.CREATE, label: 'Create tasks for others' },
  { name: TASKS_ACTIONS.VIEW_ALL, label: 'See all tasks of the store' },
];

/** The permission to create for a task action (`createPermissionV2`). */
export const tasksActionPermission = (definition: TasksActionDefinition) => ({
  resource: { type: ResourceTypeV2.ACTION, name: definition.name },
  action: ActionV2.PERFORM,
  description: `tasks: ${definition.label}`,
});
